const AUTO_RELOAD_ATTEMPT_STORAGE_KEY = 'error-boundary-auto-reload-attempt';
const MINIMUM_INTERVAL_BETWEEN_AUTO_RELOADS_IN_MS = 60 * 1000;

export const hasRecentAutoReloadAttempt = (): boolean => {
  const lastAttemptAt = Number(sessionStorage.getItem(AUTO_RELOAD_ATTEMPT_STORAGE_KEY));

  if (!lastAttemptAt) {
    return false;
  }

  return Date.now() - lastAttemptAt < MINIMUM_INTERVAL_BETWEEN_AUTO_RELOADS_IN_MS;
};

export const storeAutoReloadAttempt = () => {
  sessionStorage.setItem(AUTO_RELOAD_ATTEMPT_STORAGE_KEY, String(Date.now()));
};
